import React,{useState} from 'react'
// import Header from '../header/Header' 
// import Footer from '../footer/Footer'
import "./Blogs.css"

export default function Blogs(element) {

    const more = "view more"
    const less = "view less"
    const [extended, setextended] = useState(0);

    const post = element.props;
    const LIMIT = 500;
    const isLong = post.description.length > LIMIT;

    return (
        <div className="container_fluid blog_container">
            <h3>{post.title}</h3>
            <div className='blog_image'>
                <img src={post.image} alt={post.title} />
                <a href={post.link} target="_blank" rel="noreferrer" style={{color:"black"}}>link to post</a>
            </div>
            <div>
            <p style={{fontWeight:"bold"}}>{post.date}</p>
            {!isLong
                ? <p>{post.description}</p>
                : extended === 0
                    ? <><p>{post.description.substring(0, LIMIT)}.....</p><button onClick={() => {setextended(1)}}>{more}</button></>
                    : <><p>{post.description}</p><button onClick={() => {setextended(0)}}>{less}</button></>}
            </div>
        </div>
    )

}